'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eannotation$002e$002dAnnotation from "./scala.annotation.-Annotation.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Panel(name, asTable, fieldCss, labelCss, panelCss) {
  this.lE = null;
  this.lD = false;
  this.rQ = null;
  this.rR = null;
  this.rS = null;
  this.lE = name;
  this.lD = asTable;
  this.rQ = fieldCss;
  this.rR = labelCss;
  this.rS = panelCss;
}
export { $c_Ldev_cheleb_scalamigen_Panel as $c_Ldev_cheleb_scalamigen_Panel };
$p = $c_Ldev_cheleb_scalamigen_Panel.prototype = new $j_scala$002eannotation$002e$002dAnnotation.$h_s_annotation_Annotation();
$p.constructor = $c_Ldev_cheleb_scalamigen_Panel;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Panel() {
}
export { $h_Ldev_cheleb_scalamigen_Panel as $h_Ldev_cheleb_scalamigen_Panel };
$h_Ldev_cheleb_scalamigen_Panel.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 76880356);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.lE));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.lD ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rQ));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rR));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rS));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 5);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Ldev_cheleb_scalamigen_Panel) && (((((this.lD === x$0.lD) && (this.lE === x$0.lE)) && (this.rQ === x$0.rQ)) && (this.rR === x$0.rR)) && (this.rS === x$0.rS))));
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 5;
});
$p.o = (function() {
  return "Panel";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.lE;
      break;
    }
    case 1: {
      return this.lD;
      break;
    }
    case 2: {
      return this.rQ;
      break;
    }
    case 3: {
      return this.rR;
      break;
    }
    case 4: {
      return this.rS;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Ldev_cheleb_scalamigen_Panel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d6)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_Panel as $isArrayOf_Ldev_cheleb_scalamigen_Panel };
var $d_Ldev_cheleb_scalamigen_Panel = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Panel, "dev.cheleb.scalamigen.Panel", ({
  d6: 1,
  cn: 1,
  co: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_Panel as $d_Ldev_cheleb_scalamigen_Panel };
